<template>
    <div class="request--sent">
        <div class="panel" primary noradius>
            <h2 class="section--title">
                Ottimo! La tua richiesta è stata inviata!
            </h2>
            <p>
                Ti invieremo una proposta al più presto, controlla frequentemente il tuo indirizzo di posta elettronica.
            </p>
            <b-button variant="light" @click="goto_home">Torna alla home</b-button>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'request-sent',
        components: {
        },
        props:
        {
            opened: {
                type: Boolean,
                default: false,
            },
            completed: {
                type: Boolean,
                default: false,
            }
        },
        created()
        {
        },
        data() {
            return {
            }
        },
        computed: {
            loading: {
                get() {
                    return this.$store.state.loading
                },
            },
        },
        mounted() {
        },
        methods:{

          goto_home(){
            this.$router.push({name: 'homepage'})
          }

        },
    }
</script>

<style lang="scss">
    .request--sent
    {
        @extend .request--block !optional;
        background-color:$primary;
        color:$white;
        padding:$grid-gutter-width/2 $grid-gutter-width;
        &--title
        {
            font-size: 28px;
            font-weight: 600;
            max-width: 75%;
            margin-bottom:$grid-gutter-width/4;
        }
        &--subtitle
        {
            font-size: 14px;
            font-weight: 400;
            max-width: 50%;
            margin-bottom:$grid-gutter-width/2;
        }
    }
</style>